<template>
    <div>
      <div class="air__utils__scrollTable mb-4">
        <a-table :rowKey="record => record.id" :columns="columns" :dataSource="data"
          :expandedRowRender="expandedRowRender" :pagination="false"
          :scroll="{ x: '100%' }" :rowSelection="computedSelect" :loading="loading">
          <template slot="driver" slot-scope="driver">
            <div class="text-wrap">
              <div class="font-weight-bold text-wrap">{{ driver.first_name + ' ' + driver.last_name }}</div>
            </div>
          </template>
          <template slot="routes" slot-scope="record">
            <div class="text-wrap">
              <a-tag v-for="route in record.routes" :key="route.id" color='green'>
                {{ route.route_no }}
              </a-tag>
            </div>
          </template>
          <!--        <template slot="description" slot-scope="description">
              <div>{{description}}</div>
            </template>-->
          <!-- <template slot="category" slot-scope="category">
            <div>{{ category.name }}</div>
          </template> -->
          <!-- <template slot="school_class" slot-scope="school_class">
            <div>{{ school_class ? school_class.name : null }}</div>
          </template> -->
          <template slot="action" slot-scope="record">
            <div class="text-nowrap">
              <a-tooltip
                placement="top"
                title="View Detail"
              >
                <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showViewVehicleDetailsModal(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-eye" />
                  </span>
                </a>
              </a-tooltip>
              <a-tooltip placement="top" title="Edit vehicle">
                <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" @click="showEditModal(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-edit" />
                  </span>
                  Edit
                </a>
              </a-tooltip>
             <a-tooltip placement="top" title="Delete vehicle">
                <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" @click="handleDelete(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </a-tooltip>
            </div>
          </template>
        </a-table>
      </div>
      <vehicle-details></vehicle-details>
      <edit-vehicle @onEdited="handleAfteredit"></edit-vehicle>
    </div>
</template>

<script>
import EditVehicle from '@/components/transport/vehicle/edit'
import VehicleDetails from '@/components/transport/vehicle/detail'

const columns = [
  { title: 'Vehicle No.', width: 100, dataIndex: 'vehicle_no', scopedSlots: { customRender: 'vehicle_no' } },
  { title: 'Registration No.', width: 200, dataIndex: 'registration_no', scopedSlots: { customRender: 'registration_no' } },
  { title: 'Driver', width: 200, dataIndex: 'driver', scopedSlots: { customRender: 'driver' } },
  { title: 'Vehicle Type', width: 150, dataIndex: 'vehicle_type', scopedSlots: { customRender: 'vehicle_type' } },
  { title: 'Routes', width: 150, scopedSlots: { customRender: 'routes' } },
  // { title: 'Location', width: 150, dataIndex: 'routes[0].location', scopedSlots: { customRender: 'routes[0].location' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]

// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'VehicleTable',
  components: {
    EditVehicle,
    VehicleDetails,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
    }
  },
  computed: {
    computedSelect: function () {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    expandedRowRender(data) {
      const columns = [
        { title: 'Student Code', dataIndex: 'student_code', key: 'student_code' },
        { title: 'Name', dataIndex: 'first_name', key: 'first_name' },
        { title: 'Last Name', dataIndex: 'last_name', key: 'last_name' },
      ]
      return (<a-table
        columns={columns}
        dataSource={data.students}
        pagination={false}
      />)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    showViewVehicleDetailsModal(record) {
      this.$eventBus.$emit('openViewVehicleDetailsModal', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this vehicle?',
        content: `Clicking yes will delete this vehicle "${record.vehicle_no}"`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/transport/vehicle/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              // console.log('resp: ', resp)
              // Custom resp status: resp.data.status (not resp.status)
              if (resp.data.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: resp.data.message,
                })
              } else {
                this.$nprogress.done()
                this.$notification['warning']({
                  message: 'Vehicle cannot be deleted!',
                  description: resp.data.message,
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
